// Date 2021-07-05 10:04:55

import emSicEmrecREocMonitor from "@/views/em/statusCollection/EmSicEmrecREocMonitor.vue";
import emSicEmrecREocTreeMap from "@/views/em/statusCollection/EmSicEmrecREocTreeMap.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/em/statusCollection/emSicEmrecREocMonitor",
        name: "emSicEmrecREocMonitor",
        component: emSicEmrecREocMonitor,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/statusCollection/emSicEmrecREocTreeMap",
        name: "emSicEmrecREocTreeMap",
        component: emSicEmrecREocTreeMap,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]